// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/wave-cyclone.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/wave-cyclone/wave-cyclone.js';

mount([g0]);
